import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem, Snackbar, Alert } from "@mui/material";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";

const CreateWarehouse = () => {
  const [title, setTitle] = useState("");
  const [seq, setSeq] = useState(1); // Default minimum 1
  const [notes, setNotes] = useState("");
  const [facilities, setFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
console.log("selectedFacility",selectedFacility)
  const accessToken = getDecryptedAccessToken()

  // Fetch Facilities
  useEffect(() => {
    ApiServices.get("/apis/default/api/facility", {
      Authorization: `Bearer ${accessToken}`,
    })
      .then((response) => {
        if (response.data?.data) {
          setFacilities(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching facilities:", error);
        setSnackbar({ open: true, message: "Failed to load facilities.", severity: "error" });
      });
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (seq <= 0) {
      setSnackbar({ open: true, message: "Sequence must be greater than 0", severity: "error" });
      return;
    }

    const payload = {
      list_id: "warehouse",
      option_id: `rcw${Math.floor(Math.random() * 1000)}`, // Generating a random ID
      title,
      seq,
      is_default: 0,
      option_value: selectedFacility,
      mapping: "",
      notes,
      codes: "",
      toggle_setting_1: 0,
      toggle_setting_2: 0,
      activity: 1,
      subtype: "",
      edit_options: 1,
    };

    try {
      const response = await ApiServices.post("/apis/default/api/listOption", payload, {
        Authorization: `Bearer ${accessToken}`,
      });
      setSnackbar({ open: true, message: "Warehouse created successfully!", severity: "success" });
      setTitle("");
      setSeq(1);
      setNotes("");
      setSelectedFacility("");
    } catch (error) {
      console.error("Error creating warehouse:", error);
      setSnackbar({ open: true, message: "Failed to create warehouse.", severity: "error" });
    }
  };

  return (
    <div style={{ padding: 20, maxWidth: 400, margin: "auto" }}>
      <h2>Create Warehouse</h2>
      <form onSubmit={handleSubmit}>
        {/* Title Input */}
        <TextField
          label="Title"
          fullWidth
          variant="outlined"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          margin="normal"
        />

        {/* Sequence Input */}
        <TextField
          label="Sequence"
          type="number"
          fullWidth
          variant="outlined"
          value={seq}
          onChange={(e) => setSeq(Number(e.target.value))}
          required
          inputProps={{ min: 1 }}
          margin="normal"
        />

        {/* Notes Input */}
        <TextField
          label="Notes"
          fullWidth
          variant="outlined"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          multiline
          rows={3}
          margin="normal"
        />

        {/* Facility Selection */}
        <TextField
          select
          label="Select Facility"
          fullWidth
          variant="outlined"
          value={selectedFacility}
          onChange={(e) => setSelectedFacility(e.target.value)}
          margin="normal"
        >
          <MenuItem value="">None</MenuItem>
          {facilities.map((facility) => (
            <MenuItem key={facility.id} value={facility.id}>
              {facility.name}
            </MenuItem>
          ))}
        </TextField>

        {/* Submit Button */}
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
          Create Warehouse
        </Button>
      </form>

      {/* Snackbar for notifications */}
      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CreateWarehouse;
